import { render } from "./Phone.vue?vue&type=template&id=92d4e7d8&ts=true"
import script from "./Phone.ts?vue&type=script&lang=ts&external"
export * from "./Phone.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__